import { AlertIcon, CheckIcon, InfoIcon } from './icons';

const TONES = {
  info: { box: 'border-border bg-surface-alt', icon: InfoIcon, iconClass: 'text-ink' },
  success: { box: 'border-border bg-surface-alt', icon: CheckIcon, iconClass: 'text-ink' },
  warning: { box: 'border-ink/30 bg-surface-alt', icon: AlertIcon, iconClass: 'text-ink' },
  error: { box: 'border-sale/50 bg-surface', icon: AlertIcon, iconClass: 'text-sale' },
};

/**
 * A short message in a box. `tone` picks the look; an error is announced at
 * once (role="alert"), the rest politely (role="status"). Pass `role={null}`
 * for text that is already on the page when it loads (not a live update).
 */
export default function Notice({ tone = 'info', title, children, actions, role = 'auto', className = '', ...rest }) {
  const { box, icon: Icon, iconClass } = TONES[tone] || TONES.info;
  const liveRole = role === 'auto' ? (tone === 'error' ? 'alert' : 'status') : role || undefined;
  return (
    <div role={liveRole} className={`flex gap-3 rounded border p-4 text-[15px] ${box} ${className}`} {...rest}>
      <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${iconClass}`} />
      <div className="min-w-0 flex-1">
        {title && <p className="font-semibold text-ink">{title}</p>}
        {children && <div className={`${title ? 'mt-1 ' : ''}text-pretty text-ink/85`}>{children}</div>}
        {actions && <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2">{actions}</div>}
      </div>
    </div>
  );
}

/** A text-style button for the `actions` of a Notice. */
export function NoticeAction({ children, ...rest }) {
  return (
    <button
      type="button"
      className="min-h-[40px] text-[14px] font-semibold text-ink underline underline-offset-4 hover:no-underline"
      {...rest}
    >
      {children}
    </button>
  );
}
